import {Cureus} from '../Cureus';

Cureus.DiversityTool = {};

//= require_tree ./DiversityTool